import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Mobile-only tabbed layout for the home page.
// - Under `md`: only the active tab's group is displayed and a sticky tab bar shows.
// - `md` and above: every group is rendered vertically (the tab bar is hidden).
const TABS = [
  { id: "highlights", label: "Highlights", sections: ["offerings"] },
  { id: "story", label: "Story", sections: ["story"] },
  { id: "events", label: "Events", sections: ["events"] },
  { id: "reviews", label: "Reviews", sections: [] },
  { id: "visit", label: "Visit", sections: ["contact"] },
];

const SEC_TO_TAB = {};
TABS.forEach((t) => t.sections.forEach((s) => (SEC_TO_TAB[s] = t.id)));

export default function MobileSections({ groups }) {
  const [active, setActive] = useState("highlights");
  const location = useLocation();

  // If the URL hash targets a section that lives inside a tab, activate that tab.
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash && SEC_TO_TAB[hash]) {
      setActive(SEC_TO_TAB[hash]);
    }
  }, [location]);

  const onTabClick = (id) => {
    setActive(id);
    // scroll to the top of the tabs on mobile
    setTimeout(() => {
      const el = document.getElementById("mobile-sections");
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -56 });
      else el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 30);
  };

  return (
    <div id="mobile-sections">
      {/* Mobile tab bar (hidden on desktop) */}
      <div
        data-testid="mobile-tabs"
        className="md:hidden sticky top-14 z-40 bg-[#0B132B]/95 backdrop-blur-xl border-y border-white/10"
      >
        <div className="overflow-x-auto no-scrollbar">
          <div className="flex gap-2 px-4 py-3 min-w-max">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={`mobile-tab-${t.id}`}
                onClick={() => onTabClick(t.id)}
                className={`shrink-0 rounded-full px-5 py-2 font-label text-[11px] tracking-[0.2em] transition-all active:scale-95 ${
                  active === t.id
                    ? "bg-primary text-primary-foreground border border-primary"
                    : "bg-white/5 text-[#F8F5F2]/70 border border-white/10"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Section groups — hide on mobile if inactive, always show on desktop */}
      {TABS.map((t) => (
        <div
          key={t.id}
          data-testid={`mobile-group-${t.id}`}
          className={`md:block ${active === t.id ? "block" : "hidden"}`}
        >
          {groups[t.id]}
        </div>
      ))}
    </div>
  );
}
